/**
 * VSPC UI API
 * Internal API
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum EOsTypeInteg {
    Unknown = 'unknown',
    Workstation = 'workstation',
    DomainController = 'domainController',
    Server = 'server',
    CentOS = 'centOS',
    Debian = 'debian',
    OracleLinux = 'oracleLinux',
    Fedora = 'fedora',
    Ubuntu = 'ubuntu',
    OpenSUSE = 'openSUSE',
    Sles = 'sles',
    RedHat = 'redHat',
    MacOS = 'macOS',
    AmazonLinux = 'amazonLinux'
};

